export default "__VITE_ASSET__B2wo90mP__"